import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { STORAGE_KEYS } from '../utils/constants';

export const useFlowData = () => {
  const location = useLocation();
  
  return useMemo(() => {
    // Primary: Route state (preferred method)
    if (location.state?.email && location.state?.flow) {
      return {
        email: location.state.email,
        isFromForgotPassword: location.state.flow === 'forgot',
        hasValidFlow: true
      };
    }

    // Fallback: localStorage
    const forgotPasswordEmail = localStorage.getItem(STORAGE_KEYS.FORGOT_PASSWORD_EMAIL);
    const pendingUser = localStorage.getItem(STORAGE_KEYS.PENDING_USER);
    const authToken = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
    const verifiedEmail = localStorage.getItem(STORAGE_KEYS.VERIFIED_EMAIL);

    // Check for forgot password flow
    if (forgotPasswordEmail) {
      return {
        email: forgotPasswordEmail,
        isFromForgotPassword: true,
        hasValidFlow: true
      };
    }

    // Check for signup flow with verified email
    if (authToken && verifiedEmail) {
      return {
        email: verifiedEmail,
        isFromForgotPassword: false,
        hasValidFlow: true
      };
    }

    // Check for pending user (signup flow)
    if (pendingUser) {
      try {
        const userData = JSON.parse(pendingUser);
        return {
          email: userData.email || '',
          isFromForgotPassword: false,
          hasValidFlow: true
        };
      } catch (error) {
        console.error('Error parsing pending user data:', error);
      }
    }

    // No valid flow found
    return {
      email: '',
      isFromForgotPassword: false,
      hasValidFlow: false
    };
  }, [location.state]);
};